(function () {
  /* ==== CONFIG ==== */
  var GIFT_VARIANT_ID = 49173542699264;    // gyoza gift variant id
  var THRESHOLD_CENTS = 45000;
  var QUALIFY_TAG = "store";               // only lines with this tag count toward spend
  /* ================ */
  if (!GIFT_VARIANT_ID) return;

  var busy = false, internalUpdate = false;

  function innerFrom(html, sel){ var d=new DOMParser().parseFromString(html,'text/html').querySelector(sel); return d?d.innerHTML:null; }

  // Read tags for a variant from the rendered cart rows
  function variantTags(variantId){
    var rows = document.querySelectorAll('#main-cart-items .cart-item');
    for (var r=0; r<rows.length; r++){
      var input = rows[r].querySelector('[data-quantity-variant-id]');
      if (input && String(input.getAttribute('data-quantity-variant-id')) === String(variantId)){
        return (rows[r].getAttribute('data-product-tags')||'').split(',').map(function(s){return s.trim();});
      }
    }
    return [];
  }

  // Only "store"-tagged lines count; KOL/collab (no store tag) are ignored.
  function qualifying(c){
    return c.items.reduce(function(s,i){
      if (i.variant_id === GIFT_VARIANT_ID) return s;
      if (variantTags(i.variant_id).indexOf(QUALIFY_TAG) === -1) return s;
      return s + i.final_line_price;
    },0);
  }
  function gift(c){ return c.items.find(function(i){ return i.variant_id===GIFT_VARIANT_ID; }); }

  function apply(sec){
    internalUpdate = true;
    if (sec['main-cart-items']){ var f=innerFrom(sec['main-cart-items'],'.js-contents'), c=document.querySelector('#main-cart-items .js-contents'); if(f!==null&&c) c.innerHTML=f; }
    if (sec['cart-icon-bubble']){ var b=document.getElementById('cart-icon-bubble'), i=innerFrom(sec['cart-icon-bubble'],'.shopify-section'); if(b&&i!==null) b.innerHTML=i; }
    setTimeout(function(){ internalUpdate=false; }, 300);
  }

  function mutate(url, payload){
    payload.sections='main-cart-items,cart-icon-bubble'; payload.sections_url=window.location.pathname;
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)}).then(function(r){return r.json();});
  }

  function evaluate(){
    if (busy) return; busy=true;
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var q=qualifying(cart), g=gift(cart);
      if (q>=THRESHOLD_CENTS && !g) return mutate('/cart/add.js',{items:[{id:GIFT_VARIANT_ID,quantity:1}]}).then(function(d){ if(d.sections) apply(d.sections); });
      if (q<THRESHOLD_CENTS && g)  return mutate('/cart/change.js',{id:g.key,quantity:0}).then(function(d){ if(d.sections) apply(d.sections); });
    }).catch(function(e){ console.error('[PWP]',e); }).finally(function(){ busy=false; });
  }

  var target=document.getElementById('main-cart-items');
  if (target){ var t; new MutationObserver(function(){ if(internalUpdate) return; clearTimeout(t); t=setTimeout(evaluate,250); }).observe(target,{childList:true,subtree:true}); }
  if (document.readyState!=='loading') evaluate(); else document.addEventListener('DOMContentLoaded', evaluate);
})();